import React from "react";
import PropTypes from "prop-types";

import {
  DEFAULT_PRIMARY_BUTTON,
  DEFAULT_SECONDARY_BUTTON,
  LandingLink,
  LandingLogo,
  normalizeMenuItems,
} from "../shared/nav";
import LandingSocialLinks from "../shared/LandingSocialLinks";

import "./styles.css";

const BASE_CLASS = "landing_layout_footer";

const LandingLayoutFooter = ({ settings }) => {
  const menuItems = normalizeMenuItems(settings?.menuItems);
  const primaryButton = settings?.primaryButton?.url
    ? settings.primaryButton
    : DEFAULT_PRIMARY_BUTTON;
  const secondaryButton = settings?.secondaryButton?.url
    ? settings.secondaryButton
    : DEFAULT_SECONDARY_BUTTON;
  const copyrightText =
    settings?.copyrightText || "Copyright 2026. All rights are protected";
  const logo = settings?.footerLogo || settings?.headerLogo;

  return (
    <footer className="landing_layout_footer">
      <div className="landing_container landing_layout_footer__container">
        <LandingLogo logo={logo} baseClass={BASE_CLASS} />

        <nav className="landing_layout_footer__menu" aria-label="Footer landing menu">
          {menuItems.map((item) => (
            <LandingLink item={item} key={`${item.title}-${item.url}`} />
          ))}
        </nav>

        <div className="landing_layout_footer__actions">
          <LandingLink
            item={primaryButton}
            className="landing_layout_footer__button landing_layout_footer__button--primary"
          />
          <LandingLink
            item={secondaryButton}
            className="landing_layout_footer__button landing_layout_footer__button--secondary"
          />
        </div>

        <LandingSocialLinks
          baseClass="landing_layout_footer"
          links={settings?.socialLinksRepeater}
        />
      </div>

      <div className="landing_layout_footer__bottom">
        <div className="landing_container">
          <p>{copyrightText}</p>
        </div>
      </div>
    </footer>
  );
};

LandingLayoutFooter.propTypes = {
  settings: PropTypes.shape({
    copyrightText: PropTypes.string,
    footerLogo: LandingLogo.shape,
    headerLogo: LandingLogo.shape,
    menuItems: PropTypes.array,
    primaryButton: LandingLink.shape,
    secondaryButton: LandingLink.shape,
    socialLinksRepeater: PropTypes.array,
  }),
};

LandingLayoutFooter.defaultProps = {
  settings: null,
};

export default LandingLayoutFooter;
